var map = {
	"./ACAM-CK-AUDIO-1.mp3": "98ff",
	"./LMB_Garden1_Music.mp3": "6917",
	"./LMB_Garden2_but_with_bird.mp3": "ad9e",
	"./LMB_Garden3.mp3": "7321",
	"./db.mp3": "c2f2",
	"./empty.mp3": "e5d3",
	"./jq.mp3": "dbcd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fa7";